//
import HrFamilyAssignmentModel from '@/models/HumanResource/HrFamilyAssignment'
import { required } from '@/services/validations'

//
export default class HrFamilyAssignmentService {

  /**
   * 
   */
  static create(familyAssignment) {
    return familyAssignment.save()
  }

  /**
   * 
   */
  static delete(familyAssignment) {
    return familyAssignment.delete()
  }
  
  /**
   * 
   */
  static getAll() {
    return this
      .model()
      .get()
  }

  /**
   * 
   */
  static getById(id) {
    return this
      .model()
      .find(id)
  }

  /**
   * 
   */
  static fields() {
    return [
      {
        type: 'text-field',
        name: 'range_letter',
        props: {
          label: 'Letra',
          rules: [required],
        }
      },
      {
        type: 'float-field',
        name: 'range_number',
        props: {
          label: 'Numero',
          rules: [required],
        }
      },
      {
        type: 'currency-field',
        name: 'amount',
        props: {
          label: 'Monto',
          rules: [required],
        }
      },
      {
        type: 'currency-field',
        name: 'min_rent',
        props: {
          label: 'Mínimo',
          rules: [required],
        }
      },
      {
        type: 'currency-field',
        name: 'max_rent',
        props: {
          label: 'Máximo',
          rules: [required],
        }
      },
    ]
  }

  /**
   * 
   */
  static headers() {
    return [
      {
        text: '#',
        value: 'id',
      },
      {
        text: 'numero',
        value: 'range_number',            
      },
      {
        text: 'letra',
        value: 'range_letter',            
      },
      {
        text: 'mínimo',
        value: 'min_rent',
        format: 'currency',
        align: 'right',
      },
      {
        text: 'máximo',
        value: 'max_rent',
        format: 'currency',
        align: 'right',
      },
      {
        text: 'monto',
        value: 'amount',
        format: 'currency',
        align: 'right',
      },
      {
        text: 'modificado',
        value: 'updated_at', 
        align: 'right',
      }
    ]
  }

  /**
   * 
   */
  static model() {
    return HrFamilyAssignmentModel
  }

  /**
   * 
   */
  static toCreate() {
    return this.model().from({
      amount: 0,
      range_letter: '',
      max_rent: 0,
      min_rent: 0,
      range_number: '',
    })
  }
}